import { gql, useQuery } from '@apollo/client'
import { planQueryResult } from './QueryResults/planQueryResult'

const useGetScoreQuery = (vars = {}) => {
    return useQuery(
        gql`
            query {
                getScoreQuery {
                    ${planQueryResult}
                }
            }
        `, {
            // fetchPolicy: 'cache-first',
            variables: vars}
    )
}

export default useGetScoreQuery